var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Page, SearchInput, SimplePagination, Table, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import { TableLoadingRow } from 'components/shared/tableLoadingRow';
import { TemplatesModal } from 'components/shared/templatesModal/templatesModal';
import TemplatesAddModal from '../../../../../containers/sections/templates/templatesAddModal';
import { TEMPLATE_NAMES } from '../../templates';
import { normalizeTemplate } from '../../utils/templates.utils';
import { TemplatesSortingDropdown } from '../templatesSortingDropdown';
import { TemplatesTableRow } from '../templatesTableRow';
const FETCH_DELAY = 1000;
export class TemplatesTab extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isConfirmModalOpen: false,
            isAddModalOpen: false,
            currentTemplate: undefined,
            waitingForFetch: false,
        };
    }
    componentDidMount() {
        this.props.templates.paramsChange({ search: '', type: this.props.templateType }, 0);
    }
    setWaitingForFetch(waitingForFetch) {
        this.setState({
            waitingForFetch,
        });
    }
    delayedFetchItems() {
        const { templates } = this.props;
        const { getItems } = templates;
        setTimeout(() => {
            getItems().then(() => {
                this.setWaitingForFetch(false);
            });
        }, FETCH_DELAY);
    }
    gotoNextPage() {
        this.props.templates.nextPage();
    }
    gotoPreviousPage() {
        this.props.templates.previousPage();
    }
    showRemoveModal(template) {
        this.setState({
            isConfirmModalOpen: true,
            currentTemplate: normalizeTemplate(template),
        });
    }
    hideRemoveModal() {
        this.setState({ isConfirmModalOpen: false });
    }
    handleDeleteTemplate() {
        var _a;
        const { templates, notificationAdd, templateType } = this.props;
        const { remove } = templates;
        const { currentTemplate } = this.state;
        analytics.settingsTemplatesRemoveTemplateConfirmed({
            templateType: templateType,
            templateName: (_a = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.name) !== null && _a !== void 0 ? _a : '',
        });
        if (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.name) {
            this.setWaitingForFetch(true);
            remove(currentTemplate.id)
                .then((r) => {
                this.setState({ isConfirmModalOpen: false });
                const notificationOptions = {
                    title: 'Template deleted',
                    text: `"${currentTemplate.name}" template has been deleted`,
                    icon: 'i-done',
                    className: 'success',
                    time: 5000,
                };
                notificationAdd(notificationOptions);
                this.delayedFetchItems();
            })
                .catch((e) => {
                const notificationOptions = {
                    title: 'An error occurred',
                    text: `An error occurred when trying to delete the "${currentTemplate.name}" template`,
                    icon: 'i-exclamation',
                    className: 'danger',
                };
                notificationAdd(notificationOptions);
                this.setWaitingForFetch(false);
                console.error('Delete error', e);
            });
        }
    }
    showAddModal() {
        analytics.settingsTemplatesAddTemplateButtonClicked({
            templateType: this.props.templateType,
        });
        this.setState({
            isAddModalOpen: true,
        });
    }
    showEditModal(template) {
        this.setState({
            isAddModalOpen: true,
            currentTemplate: normalizeTemplate(template),
        });
    }
    handleAddModalClose(canceled = false) {
        this.setState({
            isAddModalOpen: false,
            currentTemplate: undefined,
        });
        if (!canceled) {
            this.setWaitingForFetch(true);
            this.delayedFetchItems();
        }
    }
    handleSearchSubmit(search) {
        this.props.templates.paramsChange({ search }, 0);
    }
    handleSearchToggle(isOpen) {
        if (!isOpen && this.props.templates.params.search) {
            this.props.templates.paramsChange({ search: '' }, 0);
        }
    }
    handleRetry() {
        this.props.templates.getItems();
    }
    getSingleTdColSpan() {
        return this.props.hasLanguageTranslationControlFF ? 5 : 4;
    }
    renderLoadingStatus() {
        const { templates } = this.props;
        if (templates.getItemsAsyncStatus === 'failed') {
            return (_jsx(Table.Tr, { children: _jsxs(Table.Td, Object.assign({ colSpan: this.getSingleTdColSpan() }, { children: ["Something went wrong...", _jsx(Button, Object.assign({ variant: "tertiary", onClick: this.handleRetry }, { children: "Try again" }))] })) }));
        }
        return _jsx(TableLoadingRow, { colSpan: this.getSingleTdColSpan() });
    }
    renderSuccessStatus() {
        const { templates, hasLanguageTranslationControlFF, templateType } = this.props;
        const { items } = templates;
        if (items.length > 0) {
            return items.map((template, i) => (_jsx(TemplatesTableRow, { template: template, templatesOpenRemoveModal: this.showRemoveModal, templatesOpenAddModal: this.showEditModal, hasLanguageTranslationControlFF: hasLanguageTranslationControlFF, templateType: templateType }, i)));
        }
        return (_jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: this.getSingleTdColSpan() }, { children: "No templates found." })) }));
    }
    renderFoot() {
        const { templates } = this.props;
        const { hasNextPage, hasPreviousPage, getItemsAsyncStatus } = templates;
        const foot = (_jsx(Table.Tfoot, { children: _jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: this.getSingleTdColSpan() }, { children: _jsx(SimplePagination, { previousButtonClick: this.gotoPreviousPage, previousButtonDisabled: !hasPreviousPage, nextButtonClick: this.gotoNextPage, nextButtonDisabled: !hasNextPage, loading: getItemsAsyncStatus === 'loading' }) })) }) }));
        return foot;
    }
    render() {
        const { sectionTitle, templates, templateType, hasLanguageTranslationControlFF, } = this.props;
        const { currentTemplate, isAddModalOpen, isConfirmModalOpen } = this.state;
        const { hasNextPage, hasPreviousPage, getItemsAsyncStatus } = templates;
        const { waitingForFetch } = this.state;
        const showFoot = hasNextPage || hasPreviousPage;
        return (_jsxs(_Fragment, { children: [_jsx(Page.Section, Object.assign({ title: sectionTitle, controls: _jsxs(_Fragment, { children: [_jsx(SearchInput, { onSubmit: this.handleSearchSubmit, onToggle: this.handleSearchToggle }), _jsx(TemplatesSortingDropdown, { templatesParamsChange: templates.paramsChange, templateType: templateType, disabled: !!templates.params.search }), _jsx(Button, Object.assign({ onClick: this.showAddModal }, { children: `Add ${TEMPLATE_NAMES[templateType].toLowerCase()}` }))] }) }, { children: _jsxs(Table, Object.assign({ framed: true, stickyHeader: true, stickyFooter: true, headerWithBackground: true }, { children: [_jsx(Table.Thead, { children: _jsxs(Table.Tr, { children: [_jsx(Table.Th, Object.assign({ width: "30%" }, { children: "Name" })), _jsx(Table.Th, Object.assign({ width: "20%" }, { children: "Created" })), _jsx(Table.Th, Object.assign({ width: "20%" }, { children: "Updated" })), hasLanguageTranslationControlFF && (_jsx(Table.Th, Object.assign({ width: "30%" }, { children: "Languages" }))), _jsx(Table.Th, {})] }) }), _jsx(Table.Tbody, { children: !waitingForFetch && getItemsAsyncStatus === 'succeeded'
                                    ? this.renderSuccessStatus()
                                    : this.renderLoadingStatus() }), showFoot && this.renderFoot()] })) })), isAddModalOpen ? (hasLanguageTranslationControlFF ? (_jsx(TemplatesModal, { isOpen: isAddModalOpen, currentTemplate: currentTemplate, onClose: this.handleAddModalClose, type: templateType, initialValues: currentTemplate })) : (_jsx(TemplatesAddModal, { isAddModalOpen: isAddModalOpen, currentTemplate: currentTemplate, onClose: this.handleAddModalClose, initialValues: currentTemplate }))) : null, _jsx(ConfirmModal, { isShown: isConfirmModalOpen, headline: "Are you sure?", text: `Are you sure you want to remove the template
        "${currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.name}"?`, confirmText: "Yes, delete it now", cancelText: "Cancel", confirm: this.handleDeleteTemplate, cancel: this.hideRemoveModal })] }));
    }
}
__decorate([
    boundMethod
], TemplatesTab.prototype, "gotoNextPage", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "gotoPreviousPage", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "showRemoveModal", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "hideRemoveModal", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "handleDeleteTemplate", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "showAddModal", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "showEditModal", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "handleAddModalClose", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "handleSearchSubmit", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "handleSearchToggle", null);
__decorate([
    boundMethod
], TemplatesTab.prototype, "handleRetry", null);
